import he from 'he';

export default function GridViewOverlayContent({ hit, contRef }) {
    const contentItem = hit.source;
    return (
        <a className="card kits-collections" href={`${contentItem?.link ?? '/'}`} ref={contRef}>
            <span className="card-img-wrap dark-overlay">                
                {contentItem.thumbUrl && (
                    <img src={contentItem.thumbUrl} className="attachment-thumbnail-480 size-thumbnail-480" alt={contentItem.title} />
                )}
            </span>

            <span className="card-body">
                <span className="card-title">{he.decode(contentItem?.title)}</span>
                <span className="card-author-bar">
                    <span className="card-author">
                        <span className="card-author-image">
                            <img src="/wp-content/themes/dom/assets/img/directions-logo-simple.png" className="attachment-thumbnail-150 size-thumbnail-150" alt="" />
                        </span>
                        {contentItem.authors && contentItem.authors.length > 0 && (
                            <span className="card-author-text">by <br /> {contentItem.authors[0].title}</span>
                        )}
                    </span>
                    <span className="card-author-button">&nbsp;</span>
                </span>
            </span>
        </a>
    );
}